/**
 * 웹뷰 환경 여부
 * @returns
 */
export const isWebView = () => {
  return window.ReactNativeWebView;
};

/**
 * 네이티브로 데이터 전송
 * @param {*} code
 * @param {*} data
 */
export const sendNativeMessageAPI = (code, data) => {
  if (isWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ code: code, data: data }));
  } else {
    console.log('No WebView..', code, data);
  }
};
